// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2410) return "static/chunks/2410-40a930ef6f6c4a59.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8410 ? "55eb4b32" : chunkId) + "." + {"3012":"b11adcbf9f928d45","4479":"0570dc23632b6e93","8410":"172ba3cd6abf4f92"}[chunkId] + ".js";
};